import React, { useEffect } from "react";
import { useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import { PACKAGE_TYPES, STATUS_OPTIONS } from "../../utils/constant";
import {
  createChannelCategory,
  createPackage,
  getallChannel,
  updateAppVersion,
  updateChannelCategory,
  updatePackage,
} from "../../Components/service/admin";

import { loader, snackbar } from "../../utils";
import EditIcon from "@mui/icons-material/Edit";
import CustomDrawer from "../../Components/CustomDrawer/CustomDrawer";
import { AutoComplete } from "../../Components/Inputs/AutoComplete";

export const AddAppVersion = ({ onSubmit, mode, formData }) => {
  let [drawer, setDrawer] = useState(false);
  let [allChannels, setAllChannels] = useState([]);
  const {
    control,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      versionName: "",
      versionCode: "",
      //   status: "",
      //   plackage_price: "",
      //   plackage_type: null,
      //   device_limit: "",
      //   selected_channels: [],
    },
  });

  useEffect(() => {
    if (drawer) {
      getAllChannel();
    }
  }, [drawer]);

  async function getAllChannel() {
    try {
      let res = await getallChannel();
      setAllChannels(res?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  }

  async function formSubmit(data) {
    try {
      loader.start();
      if (mode === "edit") {
        let res = await updateAppVersion(formData._id, data);
        snackbar.success("App Version updated successfully");
      } else {
        let res = await createChannelCategory(data);
        snackbar.success("App Version created successfully");
      }
      onSubmit();
      reset({
        name: "",
      });
      setDrawer(false);
    } catch (error) {
      console.log(error);
    } finally {
      loader.stop();
    }
  }

  function editClick() {
    let { versionName, versionCode } = formData;

    reset({
      versionName,
      versionCode,
    });
    setDrawer(true);
  }

  return (
    <div>
      {mode === "edit" ? (
        <EditIcon className="pointer" onClick={editClick} />
      ) : (
        <button
          className="btn btn-primary btn-radius px-3"
          onClick={() => setDrawer(true)}
        >
          Channel Category
        </button>
      )}
      <CustomDrawer
        width={600}
        open={drawer}
        toggle={() => setDrawer(!drawer)}
        header={`${mode == "edit" ? "Edit" : "Add"} Package`}
      >
        <Box mt={3}>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div>
              <label className="form-label mb-1" htmlFor="name">
                Version Code
              </label>
              <Controller
                name="versionCode"
                control={control}
                rules={{
                  required: "Required",
                  validate: (value) =>
                    value.trim() !== "" || "Field cannot be empty",
                }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      onChange={onChange}
                      className={`form-control ${
                        errors.versionCode ? "Validation" : ""
                      }`}
                      placeholder=" version code"
                    />
                  );
                }}
              />
            </div>
            <div>
              <label className="form-label mb-1" htmlFor="name">
                Version Name
              </label>
              <Controller
                name="versionName"
                control={control}
                rules={{
                  required: "Required",
                  validate: (value) =>
                    value.trim() !== "" || "Field cannot be empty",
                }}
                defaultValue={null}
                render={({ field: { value, onChange } }) => {
                  return (
                    <input
                      value={value}
                      onChange={onChange}
                      className={`form-control ${
                        errors.versionName ? "Validation" : ""
                      }`}
                      placeholder=" version name"
                    />
                  );
                }}
              />
            </div>

            <div className="d-flex justify-content-end mt-3">
              <button
                className="cancelButton border-none outline-none"
                type="button"
                onClick={() => setDrawer(false)}
              >
                Cancel
              </button>
              <button className="btn btn-primary m-1" type="submit">
                {mode == "edit" ? "Update" : "Add"} App Version
              </button>
            </div>
          </form>
        </Box>
      </CustomDrawer>
    </div>
  );
};
